/**
 * Florent Floral — Custom JS for Tinker/Horizon overlay
 * Handles: testimonials carousel
 */

document.addEventListener('DOMContentLoaded', function() {

  // ============================================================
  // Shopify preview theme product links
  // ============================================================
  // Shopify PR preview sessions can render collection/home pages while product
  // pages 404 under the preview session. Keep this scoped to unpublished preview
  // themes and make product links exit preview mode instead of dead-ending.
  (function() {
    if (!window.Shopify || !Shopify.previewMode || !Shopify.theme || Shopify.theme.role === 'main') return;

    document.querySelectorAll('a[href*="/products/"]').forEach(function(link) {
      if (!link.href) return;

      try {
        var url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin || url.pathname.indexOf('/products/') !== 0) return;
        if (!url.searchParams.has('preview_theme_id')) {
          url.searchParams.set('preview_theme_id', '');
          link.href = url.toString();
        }
      } catch (e) {
        // Leave malformed or non-standard links untouched.
      }
    });
  })();

  // ============================================================
  // Testimonials carousel
  // ============================================================
  const testimonialContainer = document.querySelector('[data-ff-testimonials]');
  if (testimonialContainer) {
    const cards = testimonialContainer.querySelectorAll('.ff-testimonials__card');
    const dots = testimonialContainer.querySelectorAll('[data-ff-testimonials-dot]');
    const prevBtn = testimonialContainer.querySelector('[data-ff-testimonials-prev]');
    const nextBtn = testimonialContainer.querySelector('[data-ff-testimonials-next]');
    const toggleBtn = testimonialContainer.querySelector('[data-ff-testimonials-toggle]');
    const toggleIcon = testimonialContainer.querySelector('[data-ff-testimonials-toggle-icon]');
    const PAUSE_ICON = '<rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/>';
    const PLAY_ICON = '<polygon points="7 4 20 12 7 20 7 4"/>';
    let current = 0;
    let autoPlay;
    let isHovered = false;
    let isFocused = false;
    const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Tracks the visitor's explicit play/pause choice (via the toggle button),
    // separate from the transient hover/focus pauses below, so a manual pause
    // isn't silently overridden the next time the pointer leaves the carousel.
    // Starts paused for prefers-reduced-motion visitors so they never see the
    // auto-advance.
    let userWantsPlaying = !prefersReducedMotion;

    function showSlide(index) {
      cards.forEach(function(card) { card.classList.remove('is-active'); });
      dots.forEach(function(dot) { dot.classList.remove('is-active'); });
      current = (index + cards.length) % cards.length;
      cards[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function stopAutoPlay() {
      clearInterval(autoPlay);
    }

    function startAutoPlay() {
      stopAutoPlay();
      if (!userWantsPlaying || cards.length <= 1) return;
      autoPlay = setInterval(function() {
        showSlide(current + 1);
      }, 5000);
    }

    // Only (re)starts when neither hover nor focus is still holding the
    // carousel - otherwise a prev/next/dot click (including a keyboard
    // Enter/Space activation) would restart the 5s timer while the visitor
    // is still focused inside the carousel, since no further focusin event
    // fires to catch it.
    function resumeAutoPlayIfIdle() {
      if (isHovered || isFocused) return;
      startAutoPlay();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        showSlide(current - 1);
        resumeAutoPlayIfIdle();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        showSlide(current + 1);
        resumeAutoPlayIfIdle();
      });
    }

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        showSlide(i);
        resumeAutoPlayIfIdle();
      });
    });

    function syncToggleUI() {
      if (!toggleBtn) return;
      toggleBtn.setAttribute('aria-pressed', String(!userWantsPlaying));
      toggleBtn.setAttribute('aria-label', userWantsPlaying ? 'Pause testimonial autoplay' : 'Resume testimonial autoplay');
      if (toggleIcon) toggleIcon.innerHTML = userWantsPlaying ? PAUSE_ICON : PLAY_ICON;
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function() {
        userWantsPlaying = !userWantsPlaying;
        syncToggleUI();
        resumeAutoPlayIfIdle();
      });
    }
    if (prefersReducedMotion) syncToggleUI();

    // Pause on hover and on keyboard focus, so the auto-advancing carousel
    // (WCAG 2.2.2) can be stopped by touch/keyboard users, not just mouse.
    testimonialContainer.addEventListener('mouseenter', function() {
      isHovered = true;
      stopAutoPlay();
    });
    testimonialContainer.addEventListener('mouseleave', function() {
      isHovered = false;
      resumeAutoPlayIfIdle();
    });
    testimonialContainer.addEventListener('focusin', function() {
      isFocused = true;
      stopAutoPlay();
    });
    testimonialContainer.addEventListener('focusout', function() {
      isFocused = false;
      resumeAutoPlayIfIdle();
    });

    startAutoPlay();

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        stopAutoPlay();
      } else {
        resumeAutoPlayIfIdle();
      }
    });
  }

  // ============================================================
  // Cart attributes: Occasion & Personal Message (AJAX sync)
  // Syncs cart attributes via /cart/update.js on change/input.
  // Uses event delegation so it survives Tinker's morphSection()
  // DOM re-renders in the cart drawer.
  // ============================================================
  (function() {
    var activeFetch = null;
    var debounceTimer = null;
    var observer = null;
    var occasionAutofillInFlight = false;
    var pendingOccasionAutofillValue = '';
    var sourceStorageKeys = {
      handle: 'ffCartOccasionSourceHandle',
      label: 'ffCartOccasionSourceLabel',
      manualOverrideDate: 'ffCartOccasionManualOverrideDate',
      manualOverrideSource: 'ffCartOccasionManualOverrideSource'
    };
    var cartUpdateUrl = (
      window.Theme &&
      Theme.routes &&
      Theme.routes.cart_update_url
    ) ? Theme.routes.cart_update_url : '/cart/update.js';

    function storageGet(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }

    function storageSet(key, value) {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (e) {
        // Session storage can be unavailable in private or embedded contexts.
      }
    }

    function storageRemove(key) {
      try {
        window.sessionStorage.removeItem(key);
      } catch (e) {
        // Session storage can be unavailable in private or embedded contexts.
      }
    }

    function getTodayKey() {
      var now = new Date();
      var month = String(now.getMonth() + 1).padStart(2, '0');
      var day = String(now.getDate()).padStart(2, '0');
      return now.getFullYear() + '-' + month + '-' + day;
    }

    function normalizeOccasionLabel(value) {
      return (value || '').replace(/\s+/g, ' ').trim();
    }

    function normalizeOccasionKey(value) {
      return normalizeOccasionLabel(value)
        .replace(/[‘’]/g, "'")
        .replace(/&amp;/gi, '&')
        .replace(/\s+in\s+newmarket.*$/i, '')
        .replace(/\s+(flowers?|collection)$/i, '')
        .toLowerCase();
    }

    function getElementById(id) {
      if (!document.getElementById) return null;
      return document.getElementById(id);
    }

    function extractCollectionHandle(href) {
      if (!href) return '';

      try {
        var url = new URL(href, window.location.origin);
        if (url.origin !== window.location.origin) return '';

        var match = url.pathname.match(/^\/collections\/([^/?#]+)/);
        return match ? decodeURIComponent(match[1]) : '';
      } catch (e) {
        return '';
      }
    }

    function getCurrentCollectionHandle() {
      return extractCollectionHandle(window.location.href);
    }

    function getCollectionPageLabel() {
      if (!getCurrentCollectionHandle() || !document.querySelector) return '';

      var heading = document.querySelector('h1');
      if (heading && heading.textContent) return normalizeOccasionLabel(heading.textContent);

      if (document.title) {
        return normalizeOccasionLabel(document.title.split('|')[0]);
      }

      return '';
    }

    function currentSourceKey(handle, label) {
      return (handle || storageGet(sourceStorageKeys.handle) || '') + '|' + normalizeOccasionKey(label || storageGet(sourceStorageKeys.label));
    }

    function getOccasionOptions() {
      var occasionEl = getElementById('ff-cart-occasion');
      if (!occasionEl) return [];

      return Array.prototype.slice.call(occasionEl.options)
        .filter(function(option) { return option.value; })
        .map(function(option) {
          return {
            value: normalizeOccasionLabel(option.value),
            key: normalizeOccasionKey(option.value),
            handle: option.getAttribute('data-ff-occasion-collection') || ''
          };
        });
    }

    function findOccasionSourceValue() {
      var options = getOccasionOptions();
      var sourceHandle = storageGet(sourceStorageKeys.handle) || getCurrentCollectionHandle();
      var sourceLabel = normalizeOccasionLabel(storageGet(sourceStorageKeys.label) || getCollectionPageLabel());
      var sourceOption = null;
      var sourceLabelOption = null;

      if (sourceHandle) {
        sourceOption = options.find(function(option) {
          return option.handle === sourceHandle;
        });
      }

      if (sourceLabel) {
        var sourceLabelKey = normalizeOccasionKey(sourceLabel);
        sourceLabelOption = options.find(function(option) {
          return option.key === sourceLabelKey;
        });
      }

      return sourceOption ? sourceOption.value : sourceLabelOption ? sourceLabelOption.value : '';
    }

    function trackOccasionSource(handle, label) {
      if (!handle && !label) return;

      var nextSourceKey = currentSourceKey(handle, label);
      if (storageGet(sourceStorageKeys.manualOverrideSource) !== nextSourceKey) {
        storageRemove(sourceStorageKeys.manualOverrideDate);
        storageRemove(sourceStorageKeys.manualOverrideSource);
      }

      if (handle) storageSet(sourceStorageKeys.handle, handle);
      if (label) {
        storageSet(sourceStorageKeys.label, normalizeOccasionLabel(label));
      } else if (handle) {
        storageRemove(sourceStorageKeys.label);
      }
    }

    function hasManualOccasionOverride() {
      return Boolean(storageGet(sourceStorageKeys.manualOverrideDate)) && storageGet(sourceStorageKeys.manualOverrideSource) === currentSourceKey();
    }

    function markManualOccasionOverride() {
      pendingOccasionAutofillValue = '';
      storageSet(sourceStorageKeys.manualOverrideDate, getTodayKey());
      storageSet(sourceStorageKeys.manualOverrideSource, currentSourceKey());
    }

    function postCartAttributes(attributes) {
      if (!Object.keys(attributes).length) return Promise.resolve();

      if (activeFetch) {
        activeFetch.abort();
      }

      var controller = new AbortController();
      activeFetch = controller;

      return fetch(cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes }),
        signal: controller.signal
      })
      .then(function(response) {
        activeFetch = null;
        if (!response.ok) throw new Error('Cart attribute update failed with status ' + response.status);
        return true;
      })
      .catch(function(err) {
        activeFetch = null;
        if (err.name !== 'AbortError') console.error('Cart attribute update failed:', err);
        return false;
      });
    }

    function updateRecipientField(occasionValue) {
      var labelTextEl = getElementById('ff-cart-recipient-label-text');
      var inputEl = getElementById('ff-cart-recipient');
      if (!labelTextEl && !inputEl) return;

      var isFuneral = occasionValue === 'Funeral';
      var labelText = isFuneral ? 'Name of the deceased' : 'Recipient';
      var placeholderText = isFuneral ? 'Deceased name (for funeral arrangements)' : 'Who is this for?';

      if (labelTextEl && labelTextEl.textContent !== labelText) {
        labelTextEl.textContent = labelText;
      }
      if (inputEl && inputEl.getAttribute('placeholder') !== placeholderText) {
        inputEl.setAttribute('placeholder', placeholderText);
      }
    }

    function updateCartMessageAndOccasionAttributes() {
      var occasionEl = getElementById('ff-cart-occasion');
      var messageEl = getElementById('ff-cart-message');
      var recipientEl = getElementById('ff-cart-recipient');

      if (!occasionEl && !messageEl && !recipientEl) return Promise.resolve();

      var attributes = {};
      if (occasionEl) {
        var occasionValue = occasionEl.value;
        if (!occasionValue && pendingOccasionAutofillValue && !hasManualOccasionOverride()) {
          occasionValue = pendingOccasionAutofillValue;
        }
        attributes['Occasion'] = occasionValue;
      }
      if (messageEl) {
        attributes['Personal Message'] = messageEl.value;
      }
      if (recipientEl) {
        attributes['Recipient Name'] = recipientEl.value;
      }

      return postCartAttributes(attributes).then(function(saved) {
        if (!saved || !pendingOccasionAutofillValue || hasManualOccasionOverride()) return saved;

        var currentOccasionEl = getElementById('ff-cart-occasion');
        if (currentOccasionEl && !currentOccasionEl.value) {
          currentOccasionEl.value = pendingOccasionAutofillValue;
          updateRecipientField(currentOccasionEl.value);
        }
        pendingOccasionAutofillValue = '';
        return saved;
      });
    }

    function debouncedUpdate() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        updateCartMessageAndOccasionAttributes();
      }, 300);
    }

    function flushPendingUpdate() {
      if (!debounceTimer) return;

      clearTimeout(debounceTimer);
      debounceTimer = null;
      updateCartMessageAndOccasionAttributes();
    }

    function autofillOccasionFromSource() {
      var occasionEl = getElementById('ff-cart-occasion');
      if (!occasionEl || occasionEl.value || occasionAutofillInFlight || hasManualOccasionOverride()) return;

      var sourceValue = findOccasionSourceValue();
      if (!sourceValue) return;

      occasionAutofillInFlight = true;
      pendingOccasionAutofillValue = sourceValue;
      updateCartMessageAndOccasionAttributes().finally(function() {
        occasionAutofillInFlight = false;
      });
    }

    function watchForOccasionField() {
      if (observer || !document.body || typeof MutationObserver === 'undefined') return;

      observer = new MutationObserver(function() {
        autofillOccasionFromSource();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    trackOccasionSource(getCurrentCollectionHandle(), getCollectionPageLabel());
    autofillOccasionFromSource();
    watchForOccasionField();
    // Label the Recipient field from the saved occasion on first paint.
    updateRecipientField(getElementById('ff-cart-occasion') ? getElementById('ff-cart-occasion').value : '');

    document.addEventListener('click', function(e) {
      var link = e.target && e.target.closest ? e.target.closest('a[href*="/collections/"]') : null;
      if (!link) return;

      trackOccasionSource(extractCollectionHandle(link.href), link.textContent);
      autofillOccasionFromSource();
    });

    document.addEventListener('click', function(e) {
      var productLink = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
      if (!productLink) return;

      trackOccasionSource(getCurrentCollectionHandle(), getCollectionPageLabel());
      autofillOccasionFromSource();
    });

    // Tinker dispatches this before morphSection() on cart line updates.
    // Flush pending textarea debounce so typed content is persisted first.
    document.addEventListener('cart:update', flushPendingUpdate);

    // Select fires once on change — no debounce needed
    document.addEventListener('change', function(e) {
      if (e.target && e.target.hasAttribute('data-ff-cart-attribute') && e.target.tagName === 'SELECT') {
        if (e.target.id === 'ff-cart-occasion') {
          markManualOccasionOverride();
          clearTimeout(debounceTimer);
          debounceTimer = null;
          updateRecipientField(e.target.value);
        }
        updateCartMessageAndOccasionAttributes();
      }
    });

    // Textarea/input fires on every keystroke — debounce
    document.addEventListener('input', function(e) {
      if (e.target && e.target.hasAttribute('data-ff-cart-attribute') && (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'INPUT')) {
        debouncedUpdate();
      }
    });
  })();

  // ============================================================
  // YouTube behind-the-scenes video
  // Keep third-party player markup out of the initial page. The iframe
  // is created only after an explicit, keyboard-accessible user action.
  // ============================================================
  document.querySelectorAll('[data-ff-youtube-video]').forEach(function(videoCard) {
    var trigger = videoCard.querySelector('[data-ff-youtube-trigger]');
    var target = videoCard.querySelector('[data-ff-youtube-target]');
    var videoId = videoCard.dataset.videoId;

    if (!trigger || !target || !videoId) return;

    trigger.addEventListener('click', function() {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0';
      iframe.title = trigger.getAttribute('aria-label') || 'Florent Floral behind-the-scenes video';
      iframe.loading = 'lazy';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.className = 'ff-video-feature__iframe';
      target.replaceChild(iframe, trigger);
    }, { once: true });
  });

  // ============================================================
  // Roadhouse & Rose CTA analytics
  // Content links opt in with data-ff-cta or data-ff-cta-call.
  // ============================================================
  (function() {
    /**
     * @param {string} eventName
     * @param {Record<string, string>} params
     */
    function sendRoadhouseEvent(eventName, params) {
      var gtag = /** @type {any} */ (window).gtag;
      if (typeof gtag === 'function') {
        gtag('event', eventName, params || {});
        return;
      }

      var dataLayer = /** @type {any} */ (window).dataLayer = /** @type {any} */ (window).dataLayer || [];
      dataLayer.push(Object.assign({ event: eventName }, params || {}));
    }

    document.addEventListener('click', function(event) {
      var clickTarget = event.target instanceof Element ? event.target : null;
      var cta = clickTarget ? clickTarget.closest('[data-ff-cta], [data-ff-cta-call]') : null;
      if (!cta) return;

      var ctaValue = cta.getAttribute('data-ff-cta') || cta.getAttribute('data-ff-cta-call') || 'reassure_call';
      var pageHandle = window.location.pathname.split('/').filter(Boolean).pop() || '';
      sendRoadhouseEvent('ff_roadhouse_cta_click', { cta: ctaValue, placement: pageHandle });
    });
  })();

  // ============================================================
  // Press proof and press-page CTA analytics
  // Uses the storefront's existing gtag instance; no new dependency.
  // ============================================================
  (function() {
    var pressProof = document.querySelector('[data-ff-press-proof]');

    /**
     * @param {string} eventName
     * @param {Record<string, string>} params
     */
    function sendPressEvent(eventName, params) {
      var gtag = /** @type {any} */ (window).gtag;
      if (typeof gtag === 'function') {
        gtag('event', eventName, params || {});
        return;
      }

      // Consent/app timing can create dataLayer before exposing gtag.
      // Queue the same event shape used by cart-delivery-scheduler.js.
      var dataLayer = /** @type {any} */ (window).dataLayer = /** @type {any} */ (window).dataLayer || [];
      dataLayer.push(Object.assign({ event: eventName }, params || {}));
    }

    if (pressProof) {
      var viewSent = false;
      var sendView = function() {
        if (viewSent) return;
        viewSent = true;
        sendPressEvent('ff_press_proof_view', { placement: 'homepage' });
      };

      if (typeof IntersectionObserver === 'function') {
        var pressObserver = new IntersectionObserver(function(entries) {
          if (!entries.some(function(entry) { return entry.isIntersecting; })) return;
          sendView();
          pressObserver.disconnect();
        }, { threshold: 0.35 });
        pressObserver.observe(pressProof);
      } else {
        sendView();
      }
    }

    document.addEventListener('click', function(event) {
      var clickTarget = event.target instanceof Element ? event.target : null;
      var proofLink = clickTarget ? clickTarget.closest('[data-ff-press-proof-link]') : null;
      if (proofLink) {
        sendPressEvent('ff_press_proof_click', {
          placement: 'homepage',
          link_url: proofLink.getAttribute('href') || ''
        });
        return;
      }

      var pageCta = clickTarget ? clickTarget.closest('[data-ff-press-cta]') : null;
      if (pageCta) {
        sendPressEvent('ff_press_cta_click', {
          cta_name: pageCta.getAttribute('data-ff-press-cta') || '',
          link_url: pageCta.getAttribute('href') || ''
        });
        return;
      }

      // Syndicated copies of the company announcement (press page only).
      var syndication = clickTarget ? clickTarget.closest('[data-ff-press-syndication]') : null;
      if (syndication) {
        sendPressEvent('ff_press_syndication_click', {
          destination: syndication.getAttribute('data-ff-press-syndication') || '',
          link_url: syndication.getAttribute('href') || ''
        });
        return;
      }
    });
  })();

  // ============================================================
  // Contact & phone/WhatsApp interaction analytics
  // Reuses the storefront's existing gtag instance (same pattern as the
  // press analytics above); no new dependency. Site-wide so tel:/wa.me
  // links in the footer and elsewhere are captured too.
  // ============================================================
  (function() {
    /**
     * @param {string} eventName
     * @param {Record<string, string>} params
     */
    function sendContactEvent(eventName, params) {
      var gtag = /** @type {any} */ (window).gtag;
      if (typeof gtag === 'function') {
        gtag('event', eventName, params || {});
        return;
      }

      // Consent/app timing can create dataLayer before exposing gtag.
      var dataLayer = /** @type {any} */ (window).dataLayer = /** @type {any} */ (window).dataLayer || [];
      dataLayer.push(Object.assign({ event: eventName }, params || {}));
    }

    // Rough placement hint for tel:/wa.me links: footer vs. the contact page.
    function linkLocation(link) {
      if (link.closest('footer, [class*="footer"]')) return 'footer';
      if (document.querySelector('form[id^="ContactForm-"]')) return 'contact';
      return 'page';
    }

    // Contact form submission (Shopify contact form, id prefix "ContactForm-").
    document.addEventListener('submit', function(event) {
      var form = event.target instanceof HTMLFormElement ? event.target : null;
      if (form && form.id && form.id.indexOf('ContactForm-') === 0) {
        sendContactEvent('contact_form_submit', {
          location: 'contact',
          form_id: form.id
        });
      }
    });

    // Any click on a tel: link (site-wide, incl. footer).
    document.addEventListener('click', function(event) {
      var clickTarget = event.target instanceof Element ? event.target : null;
      var telLink = clickTarget ? clickTarget.closest('a[href^="tel:"]') : null;
      if (telLink) {
        sendContactEvent('phone_click', {
          location: linkLocation(telLink),
          link_url: telLink.getAttribute('href') || ''
        });
        return;
      }

      // Any click on a wa.me link (site-wide, incl. footer).
      var waLink = clickTarget ? clickTarget.closest('a[href*="wa.me"]') : null;
      if (waLink) {
        sendContactEvent('whatsapp_click', {
          location: linkLocation(waLink),
          link_url: waLink.getAttribute('href') || ''
        });
      }
    });
  })();

  // ============================================================
  // Google Merchant Center store widget — accessibility fix
  // The Google & YouTube channel app injects iframe#merchantwidgetiframe
  // without a title attribute. Add one idempotently after it appears.
  // Safe: targets only that specific iframe, disconnects observer after
  // applying the title, does not access cross-origin iframe content.
  // ============================================================
  (function() {
    if (typeof MutationObserver === 'undefined') return;
    var TIMEOUT_MS = 10000;
    var applied = false;

    function titleMerchantIframe() {
      var iframe = document.getElementById('merchantwidgetiframe');
      if (iframe && !applied) {
        iframe.setAttribute('title', 'Google customer reviews');
        applied = true;
        return true;
      }
      return false;
    }

    // Immediate check — iframe may already be in the DOM
    if (titleMerchantIframe()) return;

    var observer = new MutationObserver(function() {
      if (titleMerchantIframe()) {
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    // Safety timeout — disconnect if widget never appears
    setTimeout(function() {
      if (!applied) observer.disconnect();
    }, TIMEOUT_MS);
  })();

  // ============================================================
  // Hero clearance — track the real overlaid header bottom
  // ============================================================
  // The hero is pulled up under the transparent header, so its visible
  // heading must clear the FULL overlaid chrome bottom = max(postal strip
  // bottom, announcement bar bottom, header nav bottom). A fixed clearance
  // (140px) works for today's copy, but the announcement text is editable and
  // can wrap to more lines, the postal strip grows when a lookup renders a
  // result, and the strip is the first child of #header-group directly above
  // the bar: each of those grows the chrome and re-covers the heading. Measure
  // the chrome with a ResizeObserver (mirroring header.js) and expose a
  // --ff-hero-measured-clearance that the CSS turns into the hero top padding
  // with a no-JS/first-paint fallback. Round to an int and write only on
  // change to avoid layout thrash.
  //
  // Measured at EVERY width, not just mobile. The value used to be skipped above
  // 749px while the CSS that consumes it (the pulled-up hero's stacked padding) switches
  // at 768px, so 750-768px fell back to the static 140px and the announcement bar landed
  // on the heading (measured at 768 on a fresh load: h1Top - barBottom +10 against live's
  // +74, and h1Top - headerBottom -20, i.e. the header overlapped the H1 before any
  // lookup). Writing it at every width fixes 750-768. The hero padding below 769px
  // consumes it; at 1024px+ the desktop hero keeps its own live-identical composition
  // (measured: 148px of padding already clears the full chrome bottom by 84px there, and
  // re-driving it would move the live-matched hero content down 24px).
  (function() {
    if (typeof ResizeObserver === 'undefined' || typeof requestAnimationFrame === 'undefined') return;
    var GAP = 10;         // px of breathing room below the overlaid header
    var FALLBACK = 140;   // px; must match the no-JS CSS fallback
    var PROPERTY = '--ff-hero-measured-clearance';
    // Everything the theme stacks above the hero's content: the postal strip is the first child of
    // #header-group, then the announcement bar, then the header's own nav rows (absolutely
    // positioned over the hero on the homepage, so a bounding-rect bottom is what counts).
    var CHROME_SELECTORS = '#ff-postal-check, .ff-announcement-bar, #header-component, .header__row--top';
    var bound = false;
    var rafId = null;

    /** Bottom edge of the lowest piece of overlaid chrome, or 0 when none is rendered. */
    function chromeBottom() {
      var bottom = 0;
      var nodes = document.querySelectorAll(CHROME_SELECTORS);
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (!(node instanceof HTMLElement)) continue;
        var rect = node.getBoundingClientRect();
        if (rect.height > 0) bottom = Math.max(bottom, rect.bottom);
      }
      return bottom;
    }

    function roundedClearance() {
      var content = document.querySelector('.ff-hero-banner__content');
      if (!content) return null;
      var bottom = chromeBottom();
      if (!bottom) return null;
      // Anchor to the HERO's own top, not to the copy block's.
      // The clearance answers "how much room below the chrome does the top of the
      // hero need". Since round 5 the copy is docked to the hero's bottom edge, so
      // the content block's own top sits *below* the chrome and
      // `bottom - contentTop` collapses to the fallback clamp (measured 140px at
      // 390x844 against the correct 224px), which would both under-size the hero
      // and put the H1 back under the header. In the layout this formula shipped
      // with, the content block starts exactly at the hero's top, so the value is
      // unchanged at every width.
      var hero = document.querySelector('.ff-hero-banner');
      var anchorTop = (hero || content).getBoundingClientRect().top;

      // Clamp at the CSS fallback so we never regress below the current
      // verified baseline; only grows when the measured header exceeds it.
      return Math.max(FALLBACK, Math.round(bottom + GAP - anchorTop));
    }

    function apply() {
      rafId = null;
      // Clearance only matters where the hero is visible under the header
      // (first viewport). If we recompute while scrolled away the viewport
      // relative anchor (content top) and the possibly-pinned nav are no
      // longer aligned, so skip distant recomputes rather than write a bad value.
      var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (scrollY > 24) return;
      var value = roundedClearance();
      if (value === null) return;
      var current = document.documentElement.style.getPropertyValue(PROPERTY);
      if (current === value + 'px') return; // already applied — avoid reflow
      document.documentElement.style.setProperty(PROPERTY, value + 'px');
    }

    function schedule() {
      if (rafId === null) rafId = requestAnimationFrame(apply);
    }

    function bind() {
      var hero = document.querySelector('.ff-hero-banner');
      if (bound || !hero) return;
      bound = true;

      // Observe every piece of chrome, the postal strip included: the strip's height changes when a
      // lookup renders a result (and the announcement copy is editable in the editor), so the
      // clearance has to be re-measured at that moment — that is what keeps the announcement bar
      // off the heading after a check.
      var ro = new ResizeObserver(schedule);
      var nodes = document.querySelectorAll(CHROME_SELECTORS);
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (node instanceof HTMLElement) ro.observe(node);
      }
      window.addEventListener('resize', schedule);
      // The theme writes --header-group-height on <body> after this script runs (the inline script in
      // theme.liquid, then utilities.js / header.js from their own observers), and that is what pulls
      // the hero up under the chrome. The hero content's own top is part of the clearance formula, so
      // re-measure when it moves: measuring only at bind() time takes the anchor from the unpulled
      // layout and comes out short (measured at 768px on a fresh load: 221px written against the
      // correct 238px, leaving the header 3px over the H1). `load` is the backstop for fonts/images
      // that change the chrome without touching <body>'s style attribute.
      if (typeof MutationObserver !== 'undefined' && document.body) {
        new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['style'] });
      }
      window.addEventListener('load', schedule);
      // Theme editor re-renders the section when the merchant edits copy/the
      // bar; re-measure once the new nodes land.
      document.addEventListener('shopify:section:load', schedule);
      apply();
    }

    bind();
    // The hero/bar can mount after DOMContentLoaded (deferred sections /
    // editor). Watch once and bind when they appear.
    if (!bound) {
      var mo = new MutationObserver(function() {
        if (bound || !document.querySelector('.ff-hero-banner')) return;
        bind();
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function() { mo.disconnect(); }, 15000);
    }
  })();

});

// ============================================================
// Hero CTA ↔ sticky-pill handoff (round 7 / C3; round 11 / F2)
// ============================================================
// The phone hero has always shipped TWO "Shop Flowers" buttons: the in-hero
// button and the fixed `.ff-hero-sticky-cta` pill, both on the first screen,
// in two different treatments. The pill is now opt-in
// (`.ff-hero-sticky-cta--show`, see assets/florent-custom.css) and this block
// is the only thing that turns it on: exactly one primary CTA is visible at the
// top of the page, and the pill takes over once the hero's own CTA has scrolled
// out of the viewport (scrolling back up hands it back).
//
// Its own DOMContentLoaded listener rather than another IIFE inside the
// handler above: an exception thrown by any earlier block there would abort
// the handler and leave the pill permanently invisible, i.e. a silent
// regression of the phone's fallback CTA.
//
// Round 11 (F2) — DETERMINISM. Round 7 drove this from an IntersectionObserver
// bound once, at DOMContentLoaded, with `if (!pill) return;` in front of it.
// Two failure modes followed, both measured by the round-11 review as "the pill
// never rendered at any scroll depth" on 2 of 3 phone loads:
//   1. If the hero section's markup was not in the DOM yet when
//      DOMContentLoaded fired (deferred / re-rendered sections, the theme
//      editor, a slow app embed above it), that early return bound nothing and
//      the pill could stay `display: none` for the WHOLE session — a status
//      control that works 1 load in 3.
//   2. The pill's visibility was only ever written from inside an observer
//      callback, so a read taken before that callback ran (or a scroll that
//      never crossed the observer's threshold) still saw the hidden state.
// The state is now DERIVED from the hero CTA's own box, synchronously, on bind,
// on scroll, on resize and on load: a single visible primary CTA is a fact of
// the layout rather than of an observer's timing. The bind retries until the
// pill exists (mutation observer + bounded timers), and if there is no hero CTA
// at all — or the hero CTA is a zero-size box (display:none at a breakpoint, a
// hidden hero variant) — the pill becomes the fallback CTA, because "never
// show it" is the worse failure.
document.addEventListener('DOMContentLoaded', function() {
  /** @type {Element|null} */
  var pill = null;
  /** @type {Element|null} */
  var heroCta = null;
  var bound = false;

  // Round 12 (G1b): the dismissal is remembered for the SESSION, so a shopper who
  // closes the pill does not get it back on the next scroll, the next resize or a
  // reload in the same tab. sessionStorage (not localStorage) on purpose: it is a
  // per-tab, per-visit preference, not a permanent account-level setting.
  var DISMISS_KEY = 'ff-hero-sticky-cta-dismissed';

  /** Reads the session flag; storage access can throw in a sandboxed/blocked context. */
  function readDismissed() {
    try {
      return !!(window.sessionStorage && window.sessionStorage.getItem(DISMISS_KEY) === '1');
    } catch (error) {
      return false;
    }
  }

  /** Writes the session flag; a blocked store still dismisses for this page view. */
  function writeDismissed() {
    try {
      if (window.sessionStorage) window.sessionStorage.setItem(DISMISS_KEY, '1');
    } catch (error) {
      /* ignore — the in-memory flag below is what the rest of this session uses */
    }
  }

  var dismissed = readDismissed();

  function resolveHeroCta() {
    return document.querySelector('.ff-hero-banner__content .ff-hero-banner__btn') ||
           document.querySelector('.ff-hero-banner__override-cta .ff-hero-banner__btn');
  }

  // One writer, one rule: the pill is shown exactly when the hero's own CTA is
  // not visible. Synchronous on purpose — an rAF-deferred write would leave the
  // state stale for a scroll read taken in the same frame. A dismissed pill is
  // the one state that overrides the rule: it stays hidden whatever the hero CTA
  // does (before round 12 nothing could dismiss it at all).
  function sync() {
    if (!pill || !pill.isConnected) return;
    var show = !dismissed;
    if (show && heroCta && heroCta.isConnected) {
      var rect = heroCta.getBoundingClientRect();
      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      var inView = rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < viewportH;
      show = !inView;
    }
    pill.classList.toggle('ff-hero-sticky-cta--show', show);
  }

  // The close control. Bound separately from `sync` (and re-bound by the theme
  // editor's section:load handler, which replaces the node) so a re-render can
  // never leave the pill dismissible-but-unwired.
  function bindDismiss() {
    if (!pill || pill.getAttribute('data-ff-sticky-bound') === '1') return;
    /** @type {Element} */
    var target = /** @type {Element} */ (pill);
    var control = target.querySelector('[data-ff-sticky-dismiss]');
    if (!control) return;
    target.setAttribute('data-ff-sticky-bound', '1');
    control.addEventListener('click', function() {
      dismissed = true;
      writeDismissed();
      target.classList.remove('ff-hero-sticky-cta--show');
      // The control is display:none from here on, so focus has to land somewhere
      // real — the top of the page is where a shopper who just closed a bottom
      // bar expects to be.
      var topOfPage = /** @type {HTMLElement|null} */ (
        document.querySelector('.skip-to-content-link, a[href="#MainContent"]')
      );
      if (topOfPage && topOfPage.focus) topOfPage.focus();
    });
  }

  function bind() {
    if (bound) return true;
    var nextPill = document.querySelector('.ff-hero-sticky-cta');
    if (!nextPill) return false;
    pill = nextPill;
    heroCta = resolveHeroCta();
    bound = true;
    bindDismiss();
    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    window.addEventListener('orientationchange', sync);
    window.addEventListener('load', sync);
    return true;
  }

  bind();

  if (!bound) {
    var observer = new MutationObserver(function() {
      if (bind()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    // Bounded retries as well as the observer: a section that mounts without a
    // childList mutation we can see (or a DOM the observer misses) must still
    // end up bound. Same 15s horizon the header binder above uses.
    [250, 750, 1500, 3000, 6000, 12000].forEach(function(delay) {
      // Bare setTimeout, not window.setTimeout: the behavior unit tests run this
      // file in a sandbox whose fake window exposes addEventListener but not the
      // timer functions (they live on the sandbox global), and the header binder
      // above already calls it the same way.
      setTimeout(function() {
        if (bind()) observer.disconnect();
      }, delay);
    });
    setTimeout(function() { observer.disconnect(); }, 15000);
  }

  // The theme editor re-renders the section (and can replace the pill element);
  // re-resolve and re-derive rather than keeping a detached node. Round 12: the
  // close control is re-bound too, or the re-rendered pill would be unwired.
  document.addEventListener('shopify:section:load', function() {
    var nextPill = document.querySelector('.ff-hero-sticky-cta');
    if (!nextPill) return;
    pill = nextPill;
    heroCta = resolveHeroCta();
    bound = true;
    bindDismiss();
    sync();
  });
});


// ============================================================
// Delivery index — the "Show all N towns" disclosure reports its state
// ============================================================
// Round 9 (D1). The page-foot delivery index used to show the same summary
// whether the row was open or shut, and shipped no aria-expanded at all
// (measured live at 1440x900: identical label before and after expansion,
// aria-expanded null, page 4894 -> 5019px). The label now flips in CSS
// (`.ff-delivery-map__summary-label--more/--less`); this keeps the attribute —
// the thing assistive tech reads — in step with the same `<details>` state, on
// both the initial render and every toggle. Own listener for the same reason the
// sticky-CTA handoff has one: a throw earlier in a shared handler must not leave
// the row announcing a state it is not in.
document.addEventListener('DOMContentLoaded', function() {
  var disclosures = document.querySelectorAll('.ff-delivery-map__disclosure');
  for (var i = 0; i < disclosures.length; i++) {
    (function(details) {
      var summary = details.querySelector('.ff-delivery-map__summary');
      if (!summary) return;
      var sync = function() {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      };
      sync();
      details.addEventListener('toggle', sync);
    })(disclosures[i]);
  }
});
